import axios from 'axios';
import { NotificationAction } from './notificattion.action';
import { getServerCore, defaultSnackbarTimeout } from '../../../../utils';
import { showSuccessSnackbar } from '../../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const authUrl = serverUrls.getAuthUrl();

export const fetchNotificationyAsync = (batch, limit) => {
    return async (dispatch, getState) => {
        
        try {
            let { _id } = getState().auth.user;
            dispatch(NotificationAction.fetchNotificationStart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/getAllNotifications/${_id}?skip=${batch*limit}&limit=${limit}`,
                headers: {
                    'Content-Type': "application/json"
                }
            });

            if (data.responseCode === 200) {
                return dispatch(NotificationAction.fetchNotificationSuccess(data.responseData));
                // return dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            }
            return dispatch(NotificationAction.fetchNotificationError());
        } catch (error) {
            dispatch(NotificationAction.fetchNotificationError());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const updateNotificationStatusAsync = () => {
    return async (dispatch, getState) => {
        
        try {
            let { _id } = getState().auth.user;
            dispatch(NotificationAction.updateNotificationStatusStart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/updateNotificationStatus/${_id}`,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.responseCode === 200) {
                dispatch(NotificationAction.updateNotificationStatusSuccess(data.responseData.data));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            }
            return dispatch(NotificationAction.updateNotificationStatusError());
        } catch (error) {
            dispatch(NotificationAction.updateNotificationStatusError());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}